export class DatosPersonales {
	public nombreCompleto: string;
    public documento: string;
    public tipoDocumento: string;
    public codigoPaisEmisor: string;
    public email: string;
    public telefono: string;
}